module.exports = __webpack_public_path__ + "media/images/about-us-img-03-e4eace4c4144bf188f2309b1649f62a6.jpg";